import { formatHex, interpolate, samples } from 'culori';
var defaultCategoriesNumber = 10;
function equidistantColors(startColor, endColor, numberOfColors) {
  if (numberOfColors > 2) {
    var interpolation = interpolate([startColor, endColor], 'lch');
    return samples(numberOfColors).map(interpolation).map(color => formatHex(color));
  }
  return [startColor, endColor];
}
function numberOfCategories(options) {
  var {
    series,
    drilldown
  } = options;
  var categories;
  var drilldownNumber;
  if (series && series.length > 1) {
    categories = series.filter(serie => serie.data).length;
  }
  if (series && series.length === 1) {
    var _series$0$data;
    categories = (_series$0$data = series[0].data) === null || _series$0$data === void 0 ? void 0 : _series$0$data.length;
  }
  if (drilldown) {
    var _drilldown$series, _drilldownNumber;
    drilldownNumber = (_drilldown$series = drilldown.series) === null || _drilldown$series === void 0 ? void 0 : _drilldown$series.map(drill => drill.data.length);
    drilldownNumber = (_drilldownNumber = drilldownNumber) === null || _drilldownNumber === void 0 ? void 0 : _drilldownNumber.sort()[drilldownNumber.length - 1];
  }
  if (drilldownNumber && categories && drilldownNumber > categories) {
    categories = drilldownNumber;
  }
  return categories || defaultCategoriesNumber;
}
export default function colors(_ref) {
  var {
    options,
    theme
  } = _ref;
  var {
    appearance,
    highlightIndex,
    intermediaryIndex,
    negativeIndex,
    numberOfColors,
    positiveIndex
  } = options || {};
  var totalColors = numberOfColors || numberOfCategories(options);

  // The default is `categories` colors
  var colorsArray = equidistantColors(theme.colorChartStartCategories, theme.colorChartEndCategories, totalColors);
  var specialIndexes;
  switch (appearance) {
    case 'highlight':
      colorsArray = equidistantColors(theme.colorChartStartGray, theme.colorChartEndGray, totalColors - 1).slice(0);
      colorsArray.splice(highlightIndex, 0, theme.colorChartHighlight);
      break;
    case 'feedback':
      specialIndexes = [positiveIndex, negativeIndex, intermediaryIndex];
      specialIndexes = specialIndexes.filter(specialIndex => specialIndex !== undefined);
      specialIndexes.sort();
      colorsArray = equidistantColors(theme.colorChartStartGray, theme.colorChartEndGray, totalColors - specialIndexes.length).slice(0);
      for (var i = 0; i < specialIndexes.length; i += 1) {
        // eslint-disable-next-line sonarjs/no-nested-switch
        switch (specialIndexes[i]) {
          case positiveIndex:
            colorsArray.splice(positiveIndex, 0, theme.colorChartPositive);
            break;
          case intermediaryIndex:
            colorsArray.splice(intermediaryIndex, 0, theme.colorChartIntermediary);
            break;
          case negativeIndex:
            colorsArray.splice(negativeIndex, 0, theme.colorChartNegative);
            break;
          default:
            break;
        }
      }
      break;
    default:
      break;
  }
  return colorsArray;
}